import React from 'react';
import styled from 'styled-components';

import { Card, EmptyState } from '@postscript/components';
import { Permissions } from 'components/account/AccountView/users/types';
import PageHeader from 'components/layout/PageHeader';
import { usePSLabs } from 'controllers/contexts/labsFeatures';
import useHasPermission from 'hooks/useHasPermission';
import { useHistory } from 'react-router-dom';

const RestrictedCardWrapper = styled.div`
  padding: var(--spacing-6);
`;

const RESTRICTED_HEADING = "You don't have access to this page";
const RESTRICTED_DESCRIPTION =
  "Your current role doesn't include permission to view this section. If you need access, reach out to your Admin.";

interface RestrictedPageProps {
  children: React.ReactNode;
  pageTitle?: React.ReactNode;
  permission: Permissions | Permissions[];
  requireAll?: boolean;
}

export default function RestrictedPage({
  children,
  pageTitle,
  permission,
  requireAll = true,
}: RestrictedPageProps): JSX.Element {
  const { hasInitialized } = usePSLabs();
  const hasPermission = useHasPermission(permission, requireAll);
  const history = useHistory();

  if (!hasInitialized || hasPermission) return <>{children}</>;

  return (
    <>
      {pageTitle && <PageHeader pageTitle={pageTitle} />}
      <RestrictedCardWrapper>
        <Card>
          <EmptyState
            size="medium"
            heading={RESTRICTED_HEADING}
            description={RESTRICTED_DESCRIPTION}
            primaryAction={{
              text: 'Go to Dashboard',
              onClick: () => history.push('/'),
            }}
          />
        </Card>
      </RestrictedCardWrapper>
    </>
  );
}

export { RESTRICTED_HEADING, RESTRICTED_DESCRIPTION };
